import React from "react";
import { PlanetaProps } from "../hooks/usePlanetasRandom";
import Planeta from "./Planeta";
import Explotion from "./Explotion";
import useFigure from "./useFigure";

export type FigureProps = {
  planeta?: PlanetaProps;
  onClick?: () => void;
  onNoPress: () => void;
  lifeTime: number;
  move: string;
  position?: React.CSSProperties;
};

/**
 *  Figure puede ser una figura que se le va a poder hacer click. cuando asi sea,
 *  se borrara y sumara puntos al juego. Pasale por parametros el planeta que quieras, el estilo que quieras y si se quiere; una accion de click y una accion cuando no se haga click
 */
export const Figure: React.FC<FigureProps> | (() => null) = ({
  planeta,
  onClick,
  onNoPress,
  lifeTime,
  move,
  position
}) => {
  const { moveStyle, pressFigure, displayed, finishTime, clicked } = useFigure(
    lifeTime,
    onNoPress,
    onClick,
    move
  );

  if (!clicked) {
    if (displayed) {
      return (
        <Planeta
          onPress={pressFigure}
          position={position}
          image={planeta}
          moveStyle={moveStyle()}
          displayed={displayed}
          finishTime={finishTime}
        />
      );
    } else {
      return <Explotion position={position} />;
    }
  } else {
    return null;
  }
};
